import axiosInstance from '../axios/axiosInstance';

export const checkSearchQuery = async (
  searchQuery: string,
  contentType: 'gif' | 'post'
): Promise<{ response: { status: number } | null; error: any }> => {
  try {
    const response = await axiosInstance.head(
      `${process.env.NEXT_PUBLIC_BACKEND_URL}/post/search?searchQuery=${encodeURIComponent(
        searchQuery
      )}${contentType === 'gif' ? '&type=gif' : ''}`
    );
    return { response: { status: response.status }, error: null };
  } catch (error) {
    return { response: null, error };
  }
};
